import { animateScrollTo } from "./smoothScroll";

export function initBackToTopButton() {
  const backToTopButton = document.querySelector(".js-back-top");

  if (!backToTopButton) return;

  // ページ上部にセンチネル要素を作成して IntersectionObserver で監視
  const sentinel = document.createElement("div");
  sentinel.setAttribute("aria-hidden", "true");
  sentinel.style.cssText = "position:absolute;top:0;left:0;width:1px;height:300px;pointer-events:none;";
  document.body.prepend(sentinel);

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        backToTopButton.classList.add("_hidden");
        backToTopButton.setAttribute("tabindex", "-1");
      } else {
        backToTopButton.classList.remove("_hidden");
        backToTopButton.setAttribute("tabindex", "0");
      }
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);

  backToTopButton.addEventListener("click", function (e) {
    e.preventDefault();
    animateScrollTo(0);
  });
}
